module.exports = __webpack_public_path__ + "img/06.b9ecfb94.png";